export const generateUniqueInteger = () =>
	Math.floor(Date.now() + Math.random() * 1000);
export const generateUniqueBigInt = () => {
	const currentTime = BigInt(Date.now());
	const randomAddition = BigInt(Math.floor(Math.random() * 100));
	return currentTime + randomAddition;
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
